export const declination = (number: number, titles: [string, string, string]): string => {
  const cases: number[] = [2, 0, 1, 1, 1, 2];
  const abs = Math.abs(number);
  const mod100 = abs % 100;
  const mod10 = abs % 10;
  const index = mod100 > 4 && mod100 < 20 ? 2 : (cases[mod10 < 5 ? mod10 : 5] ?? 2);
  return titles[index] ?? titles[2];
};
